// extracted by mini-css-extract-plugin
module.exports = {"Ideas":"Ideas__Ideas_25BAD grid","Wrapper":"Ideas__Wrapper_9jr7n"};